<template>
  <v-chip v-if="!isEmpty(filter.value)" class="mx-1 my-1" :close="closable" @click:close="$emit('remove')">
    <span>{{ filter.name }}</span>

    <strong class="mx-1">
      {{ filter?.filterType?.matchingName }}
    </strong>

    <template v-if="isLongValue">
      <v-tooltip bottom max-width="900px">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on"> ({{ formattedValue }}) </span>
        </template>

        <span>
          {{ fullValue }}
        </span>
      </v-tooltip>
    </template>

    <template v-else>
      <span> ({{ formattedValue }}) </span>
    </template>
  </v-chip>
</template>

<script>
export default {
  name: "CustomReportFilterChip",
  props: {
    filter: {
      type: Object,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    fullValue() {
      return this.$customReport.displayFilterValue(this.filter);
    },

    isLongValue() {
      return this.fullValue && this.fullValue.length > 50;
    },

    formattedValue() {
      if (!this.fullValue) return "";

      const parts = this.fullValue.split(",");

      if (parts.length > 2) {
        return `${parts[0]}, ${parts[1]} +${parts.length - 2} more`;
      }

      const MAX_LENGTH = 50;
      return this.fullValue.length > MAX_LENGTH ? this.fullValue.substring(0, MAX_LENGTH) + "..." : this.fullValue;
    }
  },

  methods: {
    isEmpty(value) {
      if (typeof value === "string") {
        return !value || value.trim().length === 0;
      }
      return value === null || value === undefined;
    }
  }
};
</script>
